/* ============================================================
   VITAPOP HOMEPAGE v5 behaviours (vp-home-v5.js, 2026-07-03)
   - purchase module: plan toggle + gallery thumbs
   - collagen journey: IntersectionObserver stroke-draw animation
   - UGC carousel: tap-to-play videos (one at a time, pause offscreen)
   - sticky shop CTA: show after hero, hide over purchase/closer/footer
   - signup band: POST to OpsHub /api/subscribe
   - smooth scroll for #vp-purchase anchors
   All progressive enhancement. Respects prefers-reduced-motion.
   ============================================================ */
(function () {
  'use strict';
  var reduceMotion = false;
  try { reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  /* ---------- smooth scroll to purchase module ---------- */
  ready(function () {
    document.querySelectorAll('a[href="#vp-purchase"], a[href*="#vp-purchase"]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var target = document.getElementById('vp-purchase');
        if (!target) return;
        e.preventDefault();
        target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
      });
    });
  });

  /* ---------- purchase module ---------- */
  ready(function () {
    var mod = document.getElementById('vp-purchase');
    if (!mod) return;

    // gallery thumbs
    var main = mod.querySelector('[data-v5-main-img]');
    mod.querySelectorAll('[data-v5-thumb]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!main) return;
        var src = btn.getAttribute('data-v5-thumb');
        var srcset = btn.getAttribute('data-v5-thumb-srcset');
        if (src) main.src = src;
        if (srcset) main.srcset = srcset;
        mod.querySelectorAll('[data-v5-thumb]').forEach(function (b) { b.setAttribute('aria-current', 'false'); });
        btn.setAttribute('aria-current', 'true');
      });
    });

    // plan toggle
    var spInput = mod.querySelector('[data-v5-sp-input]');
    var atcLabel = mod.querySelector('[data-v5-atc-label]');
    function applyPlan() {
      var checked = mod.querySelector('input[name="v5plan"]:checked');
      if (!checked || !spInput || !atcLabel) return;
      var isSub = checked.value !== '';
      if (isSub) {
        spInput.value = checked.value;
        spInput.disabled = false;
        atcLabel.textContent = 'Add subscription · ' + (checked.getAttribute('data-price') || '');
      } else {
        spInput.value = '';
        spInput.disabled = true;
        atcLabel.textContent = 'Add to bag · ' + (checked.getAttribute('data-price') || '');
      }
    }
    mod.querySelectorAll('input[name="v5plan"]').forEach(function (r) {
      r.addEventListener('change', applyPlan);
    });
    applyPlan();
  });

  /* ---------- collagen journey animation ---------- */
  ready(function () {
    var journey = document.querySelector('.v5-journey');
    if (!journey) return;
    if (reduceMotion || !('IntersectionObserver' in window)) return; // fully static

    journey.setAttribute('data-animate', '');

    // prep icon stroke draw: normalise every shape to pathLength 1
    var steps = Array.prototype.slice.call(journey.querySelectorAll('.v5-step'));
    steps.forEach(function (step) {
      step.querySelectorAll('.v5-step__roundel svg :is(path, circle, rect)').forEach(function (shape) {
        try {
          shape.setAttribute('pathLength', '1');
          shape.style.strokeDasharray = '1';
          shape.style.strokeDashoffset = '1';
          shape.style.transition = 'stroke-dashoffset .7s ease-out';
        } catch (e) {}
      });
    });

    var fired = false;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting || fired) return;
        fired = true;
        io.disconnect();
        journey.classList.add('is-inview');
        steps.forEach(function (step, i) {
          setTimeout(function () {
            step.classList.add('is-active');
            step.querySelectorAll('.v5-step__roundel svg :is(path, circle, rect)').forEach(function (shape) {
              shape.style.strokeDashoffset = '0';
            });
          }, 200 + i * 220);
        });
      });
    }, { threshold: 0.35 });
    io.observe(journey);
  });

  /* ---------- UGC video cards ---------- */
  ready(function () {
    var videos = Array.prototype.slice.call(document.querySelectorAll('.vp-ugc__video'));
    if (!videos.length) return;

    function pauseAll(except) {
      videos.forEach(function (v) {
        if (v !== except && !v.paused) {
          v.pause();
          var card = v.closest('.vp-ugc__card');
          if (card) card.classList.remove('is-playing');
        }
      });
    }

    videos.forEach(function (v) {
      var media = v.closest('.vp-ugc__media');
      var card = v.closest('.vp-ugc__card');
      if (!media) return;
      media.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (v.paused) {
          pauseAll(v);
          var p = v.play();
          if (p && p.catch) p.catch(function () {});
          if (card) card.classList.add('is-playing');
        } else {
          v.pause();
          if (card) card.classList.remove('is-playing');
        }
      });
    });

    if ('IntersectionObserver' in window) {
      var vio = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var v = entry.target;
          if (!entry.isIntersecting && !v.paused) {
            v.pause();
            var card = v.closest('.vp-ugc__card');
            if (card) card.classList.remove('is-playing');
          }
        });
      }, { threshold: 0.2 });
      videos.forEach(function (v) { vio.observe(v); });
    }
  });

  /* ---------- sticky shop CTA ---------- */
  ready(function () {
    var sticky = document.querySelector('.v5-sticky');
    if (!sticky || !('IntersectionObserver' in window)) return;

    var hero = document.querySelector('.v5-hero');
    var suppressors = [];
    var purchase = document.getElementById('vp-purchase');
    var closer = document.querySelector('.v5-closer');
    var signup = document.querySelector('.v5-signup');
    var footer = document.querySelector('footer');
    [purchase, closer, signup, footer].forEach(function (el) { if (el) suppressors.push(el); });

    var heroPassed = false;
    var suppressed = {};
    function update() {
      var anySuppressed = Object.keys(suppressed).some(function (k) { return suppressed[k]; });
      sticky.classList.toggle('is-visible', heroPassed && !anySuppressed);
    }

    if (hero) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          heroPassed = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
          update();
        });
      }, { threshold: 0 }).observe(hero);
    } else {
      heroPassed = true;
    }

    var sio = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var key = entry.target.id || entry.target.className || entry.target.tagName;
        suppressed[key] = entry.isIntersecting;
      });
      update();
    }, { threshold: 0.05 });
    suppressors.forEach(function (el) { sio.observe(el); });
  });

  /* ---------- reviews expander ---------- */
  ready(function () {
    var widget = document.querySelector('.v5-reviews__widget');
    var expand = document.querySelector('.v5-reviews__expand');
    var btn = expand && expand.querySelector('button');
    if (!widget || !btn) return;
    btn.addEventListener('click', function () {
      var collapsed = widget.getAttribute('data-collapsed') === 'true';
      widget.setAttribute('data-collapsed', collapsed ? 'false' : 'true');
      btn.textContent = collapsed ? 'Show fewer reviews' : 'See all reviews';
    });
    // hide the expander (and the collapse mask) if the Judge.me widget never hydrates
    function checkHydration(tries) {
      var inner = widget.querySelector('.jdgm-widget');
      var hydrated = inner && inner.children.length > 0 && widget.offsetHeight > 120;
      if (hydrated) return;
      if (tries > 0) { setTimeout(function () { checkHydration(tries - 1); }, 1500); return; }
      expand.style.display = 'none';
      widget.setAttribute('data-collapsed', 'false');
    }
    checkHydration(6);
  });

  /* ---------- signup band ---------- */
  ready(function () {
    var form = document.querySelector('.v5-signup__form');
    if (!form) return;
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var input = form.querySelector('.v5-signup__input');
      var hp = form.querySelector('.v5-signup__hp');
      var btn = form.querySelector('button[type="submit"]');
      var msg = document.querySelector('.v5-signup__msg');
      var email = (input && input.value || '').trim();
      if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) {
        if (msg) { msg.textContent = 'Please enter a valid email address.'; msg.classList.add('is-error'); }
        return;
      }
      if (msg) { msg.textContent = ''; msg.classList.remove('is-error'); }
      if (btn) { btn.disabled = true; }
      fetch('https://ops.sh-tech.io/api/subscribe', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ brand: 'vitapop', email: email, hp: (hp && hp.value) || '', tag: 'prefooter' })
      }).then(function (r) { return r.json(); }).then(function (d) {
        if (d && d.ok) {
          if (msg) msg.textContent = 'You are in. Keep an eye on your inbox.';
          if (input) input.value = '';
        } else {
          if (msg) { msg.textContent = 'Something went wrong - please try again.'; msg.classList.add('is-error'); }
        }
        if (btn) btn.disabled = false;
      }).catch(function () {
        if (msg) { msg.textContent = 'Something went wrong - please try again.'; msg.classList.add('is-error'); }
        if (btn) btn.disabled = false;
      });
    });
  });
})();
